<template>
  <div class="top-filters">
    <div class="categories">
      <nuxt-link
        :to="localePath('/blog')"
        active-class="btn-violet"
        class="btn btn-primary btn-small"
      >
        {{ $t('all_articles') }}
      </nuxt-link>
      <nuxt-link
        v-for="category in store.categories"
        :key="category.title"
        :to="localePath(`/blog/${category.link}`)"
        class="btn btn-primary btn-small"
        exact-active-class="btn-violet"
      >
        {{ category.title }}
      </nuxt-link>
    </div>

    <div class="form_field input-with-btn">
      <input
        id="search_elem"
        v-model="search"
        :placeholder="`${$t('search_item')}...`"
        autocomplete="off"
        class="form_input with-icon"
        type="text"
        @input="emit('onSearch', $event.target.value)"
      >
      <label for="search_elem">
        <i class="icon i-search f18 wh43" />
      </label>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useLocalePath } from '#i18n';
import { useBlogStore } from '~/store/blog';

const emit = defineEmits(['onSearch']);
const store = useBlogStore();
const localePath = useLocalePath();

const search = ref('');
</script>

<style lang="scss" scoped>
.top-filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  .categories {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 1rem;
    align-items: flex-start;

    .categories {
      flex-wrap: wrap;
      gap: 0.5rem;
    }

    .form_field {
      width: 100%;
    }
  }
}
</style>
